import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
  width: 100%;
`;

export const SlotsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
`;

export const SlotChip = styled.div<{ isActive: boolean }>`
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid ${(props) => (props.isActive ? "#0FA457" : "#E7E7F0")};
  background-color: ${(props) => (props.isActive ? "#F3FAF7" : "#FFFFFF")};
  color: ${(props) => (props.isActive ? "#0FA457" : "#2C2C3A")};
  font-size: 14px;
  font-weight: ${(props) => (props.isActive ? "500" : "400")};
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => (props.isActive ? "#0FA457" : "#D0D0D8")};
    background-color: ${(props) => (props.isActive ? "#F3FAF7" : "#FAFAFA")};
  }
`;

